export const DEFAULT_LANGUAGE = "de";
export const languages = [DEFAULT_LANGUAGE, "fr", "it", "en"] as const;
